/* eslint-disable import/prefer-default-export */
import { useContext } from 'react';

import { SessionContext, SessionContextInterface } from './SessionContext';

export const useSessionContext = (): SessionContextInterface => useContext(SessionContext);
